export default "__VITE_ASSET__Dhdp9leb__"